<!-- 组件说明 -->
<template>
  <div>
    <!-- <view-port></view-port> -->
  </div>
</template>

<script>
import ViewPort from './common/ViewPort';

export default {
  components: { ViewPort },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
</style>


// WEBPACK FOOTER //
// src/pages/index/Index.vue